<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
    <div class="giga-actions">
      <div class="giga-actions_full giga-actions_end">
        <div
          v-if="selectDocuments.length"
          ref="dropdownContainer"
          class="giga-button menu-container"
        >
          <button
            class="giga-blue_button with-icon menu-icon"
            v-if="!isVIEWER"
            @click="toggleDropdownOpen()"
          >
            <i class="giga-icon">
              <svg
                class="fill"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 12.8538V15.5556C0 15.8045 0.195528 16 0.444383 16H3.14623C3.26177 16 3.37731 15.9556 3.4573 15.8667L13.1626 6.17025L9.82975 2.83738L0.133315 12.5338C0.0444383 12.6227 0 12.7293 0 12.8538ZM15.74 3.59283C16.0867 3.24622 16.0867 2.68629 15.74 2.33968L13.6603 0.259964C13.3137 -0.0866546 12.7538 -0.0866546 12.4072 0.259964L10.7807 1.8864L14.1136 5.21928L15.74 3.59283Z"
                  fill="white"
                />
              </svg>
            </i>
            <span>Actions en masse</span>
          </button>
          <div v-show="isDropDownOpen" class="dropdown-menu">
            <button @click="$emit('callDocumentsActions')">
              Joindre aux opérations
            </button>
            <button @click="$emit('download')">
              <span>{{ $t("download") }}</span>
            </button>
            <div
              class="giga-button hasDropdown"
              :class="{ 'active-actions_dropdown': toggleActionsDropdown }"
            >
              <button
                class="with-icon"
                v-if="!isVIEWER"
                @click="toggleDropdown()"
              >
                Type des documents
              </button>
              <div class="giga-actions_dropdown">
                <div class="giga-actions_dropdown_header">
                  <h3 class="giga-actions_dropdown_title">
                    Modifier le type de document
                  </h3>
                  <button
                    class="giga-actions_dropdown_close"
                    @click="closeDropdown()"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.256 8L15.52 2.736C15.824 2.448 16 2.048 16 1.6C16 0.72 15.28 0 14.4 0C13.952 0 13.552 0.176 13.264 0.464L8 5.744L2.736 0.464C2.448 0.176 2.048 0 1.6 0C0.72 0 0 0.72 0 1.6C0 2.048 0.176 2.448 0.464 2.736L5.744 8L0.48 13.264C0.176 13.552 0 13.952 0 14.4C0 15.28 0.72 16 1.6 16C2.048 16 2.448 15.824 2.736 15.536L8 10.256L13.264 15.52C13.552 15.824 13.952 16 14.4 16C15.28 16 16 15.28 16 14.4C16 13.952 15.824 13.552 15.536 13.264L10.256 8Z"
                        fill="#6B829A"
                      />
                    </svg>
                  </button>
                </div>

                <!-- DROPDOWN -->
                <div class="giga-actions_dropdown_body">
                  <edit-dropdown-docs-type
                    :documents="getSelectedDocuments"
                    :action-type="'edit'"
                  >
                  </edit-dropdown-docs-type>
                </div>
                <!-- END DROPDOWN -->
              </div>
            </div>
            <button
              v-if="!hideDeleteOrReplaceButton && !isVIEWER"
              @click="
                openDocumentModal(
                  isToBeCompleted ? 'replaceDocument' : 'confirm-delete'
                )
              "
            >
              <span>{{ isToBeCompleted ? $t("replace") : $t("delete") }}</span>
            </button>
          </div>
        </div>
      </div>

      <b-modal
        id="replaceDocument"
        modal-class="giga-modal p-4 big-modal"
        dialog-class="modal-lg"
        no-close-on-esc
        no-close-on-backdrop
        hide-header
        hide-footer
        lazy
      >
        <h2 class="giga-modal_title">Remplacer vos documents</h2>
        <button class="giga-modal_close" @click="hideModal('replaceDocument')">
          <b-icon icon="x" class="icon-close"></b-icon>
        </button>
        <div class="giga-modal_body">
          <transition name="slide-up">
            <add-document-step1
              :fileUploadId="'fileUpload2'"
              :replace="true"
              :isSimulation="isSimulation"
              :isToBeCompleted="isToBeCompleted"
              :selectDocuments="selectDocuments"
            ></add-document-step1>
          </transition>
        </div>
      </b-modal>

      <b-modal
        id="EditDocumentTypes"
        modal-class="p-4 big-modal modal-scroll"
        content-class="text-center pb-2"
        no-close-on-esc
        no-close-on-backdrop
        hide-header
        hide-footer
        lazy
      >
        <b-icon
          icon="x"
          @click="hideModal('EditDocumentTypes')"
          class="icon-close fsize-5 text-muted"
        ></b-icon>
        <transition name="slide-up">
          <edit-document-type
            :documents="getSelectedDocuments"
            :action-type="'edit'"
          ></edit-document-type>
        </transition>
      </b-modal>
      <confirm-modal
        id="confirm-delete"
        :content="$t('would-you-like-to-delete-the-document')"
        :loader="false"
        fontSize="h3"
        backdrop-close="false"
        @yesClick="deleteDocument()"
        @close="hideConfirmationModal()"
      ></confirm-modal>
    </div>
  </div>
</template>

<script>
import AddDocumentStep1 from "../../components/static/AddDocument/Step1";
import { mapActions, mapGetters, mapMutations } from "vuex";
// import EditDocumentType from "./AddDocument/EditDocumentType";
import EditDropdownDocsType from "./AddDocument/EditDropdownDocsType.vue";
import eventBus from "@/shared/event.bus";
import ConfirmModal from "../../components/static/ConfirmModal";
// import FilterModal from './FilterModal';
import { notificationService } from "@/views/service/notification.service";
import { map, some } from "lodash";
import AssignDocumentOperation from "@/components/static/AddDocument/AssignDocumentOperation.vue";

export default {
  name: "DocumentsActions",
  props: [
    "documents",
    "selectDocuments",
    "deletedDocument",
    "noSearch",
    "noFilter",
    "isSimulation",
    "queryConfig",
    "isVIEWER"
  ],
  components: {
    EditDropdownDocsType,
    AddDocumentStep1,
    ConfirmModal
  },
  data() {
    return {
      toggleActionsDropdown: false,
      toBeCompleted: false,
      isDropDownOpen: false
    };
  },
  mounted() {
    eventBus.$on("setCurrentStep_One", () => {
      this.setCurrentStep(1);
    });
    eventBus.$on("deleteSelectedDocument", () => {
      this.deleteDocumentsAction({ documentsIds: this.selectDocuments });
      notificationService.markNotificationsAsReadByEntityId(
        this.selectDocuments
      );
      notificationService.sendCallToActionNotificationToAigle(
        parseInt(this.$route.params["id"], 10)
      );
    });
    document.addEventListener("click", this.closeDropdownContainer);
  },
  computed: {
    ...mapGetters("document", [
      "getSelectedDocuments",
      "getDraftDocumentsReplace"
    ]),
    ...mapGetters("loader", {
      downloadDocumentLoader: "getDownloadDocumentLoader"
    }),
    hideDeleteOrReplaceButton() {
      return this.selectDocuments.length > 1 && this.isToBeCompleted;
    },
    isToBeCompleted() {
      return some(this.getSelectedDocuments, { transmitted: false });
    }
  },
  methods: {
    ...mapMutations("document", [
      "setCurrentStep",
      "setStep1Status",
      "setDraftDocumentsReplace",
      "setSelectedDocuments"
    ]),
    ...mapActions("document", [
      "deleteDocumentsAction",
      "deleteDraftDocumentsAction"
    ]),
    ...mapActions("notification", ["openModal", "closeModal"]),
    openDocumentModal(modal) {
      this.toBeCompleted = false;
      if (modal === "replaceDocument") {
        this.toBeCompleted = true;
        modal = "replaceDocument";
      }
      this.$root.$emit("bv::show::modal", modal);
    },
    hideModal(modal) {
      this.$root.$emit("bv::hide::modal", modal);
      this.setCurrentStep(1);
      if (modal === "replaceDocument") {
        this.discardDocuments();
        eventBus.$emit("unselectDocs");
      }
    },
    hideConfirmationModal() {
      this.$root.$emit("bv::hide::modal", "confirm-delete");
    },
    deleteDocument() {
      this.hideConfirmationModal();
      this.deleteDocumentsAction({ documentsIds: this.deletedDocument });
      eventBus.$emit("unselectDocs");
    },
    // onFilter(filter) {
    //   this.$emit("applyFilter", {
    //     isSimulationFilter: this.isSimulationContext,
    //     filter: filter,
    //   });
    // },
    // reloadData(filter) {
    //   this.$emit("reloadData", {
    //     isSimulationFilter: this.isSimulationContext,
    //     filter: filter,
    //   });
    // },
    toggleDropdown() {
      this.toggleActionsDropdown = !this.toggleActionsDropdown;
    },
    closeDropdown() {
      this.toggleActionsDropdown = false;
    },
    discardDocuments: function() {
      if (
        this.getDraftDocumentsReplace &&
        this.getDraftDocumentsReplace.length > 0
      ) {
        const draftDocuments = this.getDraftDocumentsReplace;
        this.setDraftDocumentsReplace(null);
        this.deleteDraftDocumentsAction({
          documentsName: map(draftDocuments, "fileName"),
          showLoader: false
        });
      }
    },
    toggleDropdownOpen() {
      this.isDropDownOpen = !this.isDropDownOpen;
    },
    closeDropdownContainer(event) {
      if (
        this.$refs.dropdownContainer &&
        !this.$refs.dropdownContainer.contains(event.target)
      ) {
        this.isDropDownOpen = false;
      }
    }
  },
  beforeDestroy() {
    eventBus.$off("deleteSelectedDocument");
    document.removeEventListener("click", this.closeDropdownContainer);
  }
};
</script>

<style>
.menu-container {
  position: relative;
  display: inline-block;
}

.menu-icon {
  cursor: pointer;
  font-size: 24px;
  padding: 8px;
  border-radius: 50%;
  transition: background 0.3s;
}

.dropdown-menu {
  position: absolute;
  top: 67%;
  left: auto;
  right: 67%;
  background: white;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 200px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding: 5px 0;
}

.dropdown-menu button {
  background: none;
  border: none;
  width: 100%;
  padding: 10px;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s;
}

.giga-button button {
  justify-content: left;
}

.dropdown-menu button:hover {
  background: #f0f0f0;
}

.giga-actions_dropdown_close {
  left: 375px !important;
}
</style>
